module.exports = __webpack_public_path__ + "static/media/android.20a7b92c.svg";